module.exports = __webpack_public_path__ + "static/media/illustration-rptstd-details.620308dc.svg";